import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.ah{gap:16px;}.ssr-plugin'
import { useState } from 'react'
import { styled } from 'inlines'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { Modal } from '../../Modal/index.js'
import { Note } from '../../Note/index.js'
import { TextAreaInput } from '../../TextAreaInput/index.js'
import { Button } from '../../Button/index.js'

export const AddEmbedModal = ({ children, onSave }) => {
  const [editor] = useLexicalComposerContext()
  const [html, setHtml] = useState('')

  return (
    <Modal>
      <Modal.Trigger>{children}</Modal.Trigger>
      <Modal.Content>
        <Modal.Header title="Embed code" />
        <Modal.Body>
          <div className="a ac ah"
          >
            <Note
              title="Remove dimensions for automatic resizing"
              description="If you would like your embedded frame to be resized automatically, remove dimensions from the code."
            />
            <TextAreaInput
              placeholder="Enter your code here"
              value={html}
              onChange={setHtml}
              rows={16}
              // autoFocus
              // onFocus={(e) => {
              //   e.target.select()
              // }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="border"
            onClick={() => {
              setHtml('')
              Modal.Close()
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onSave(html)
              setHtml('')
              Modal.Close()
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
